import SingleLink from './SingleLink';

export default SingleLink;
